import apiService from '../Api'
import { IUser } from '../User/UserService'

export interface IList {
  current_page: number
  per_page: number
  total: number
  total_selected: number
  data: ISector[]
}

export interface ISector {
  id: number
  name: string
  created_by: IUser
  created_at: string
  updated_at: string
}

export interface ICreateUpdateSector {
  name: string
}

export class SectorService {
  async list(filters: { page?: number; pageSize?: number } = {}): Promise<IList> {
    return apiService
      .get('/sector', {
        params: {
          page: filters.page ?? 1,
          page_size: filters.pageSize ?? 10
        }
      })
      .then((response) => response.data)
  }

  async listForSelect(): Promise<ISector[]> {
    return apiService.get('/sector/select').then((response) => response.data)
  }

  async create(data: ICreateUpdateSector): Promise<ISector> {
    const formData = new FormData()
    formData.append('name', data.name)

    return apiService.post('/sector', formData).then((response) => response.data)
  }

  async update(userGroupId: number, data: ICreateUpdateSector): Promise<IUser> {
    const formData = new FormData()
    formData.append('_method', 'PUT')
    formData.append('name', data.name)

    return apiService
      .post(`/sector/${userGroupId}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      .then((response) => response.data)
  }

  async destroy(id: number) {
    return apiService.delete(`/sector/${id}`).then((response) => response.data)
  }
}
